/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.fni485r{flex-wrap:wrap;}
.f6jr5hl{align-items:flex-start;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.fqerorx{flex-grow:1;}
.fuk1rnt{flex-basis:260px;}
.fuzgk9b{min-inline-size:0;}
.f1f0uekf{max-inline-size:420px;}
.f1c209jx{inline-size:100%;}
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
.fgdu4nw{padding-inline:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.ftuwxu6{display:inline-flex;}
.f122n59{align-items:center;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.fmm5bso{-webkit-padding-start:var(--spacingHorizontalM);padding-inline-start:var(--spacingHorizontalM);}
.fv8152r{-webkit-padding-end:var(--spacingHorizontalXXS);padding-inline-end:var(--spacingHorizontalXXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f18qryls{padding-block:var(--spacingVerticalXXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkhj508{font-size:var(--fontSizeBase300);}
.f16xq7d1{background-color:var(--colorNeutralBackground3);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f44lkw9{border-radius:var(--borderRadiusCircular);}
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
/** @griffel:css-end **/